import { ClubRoles } from '../services/AuthService';
import { useAuth } from './useAuth';

export function useClubRoles(clubId: string): ClubRoles {
  const { user } = useAuth();

  if (user?.isAdmin) {
    return { isManager: true };
  }

  return user?.clubs[clubId] ?? { isManager: false };
}
